import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { OCR_TIMEOUT_MS } from './ocr.constants';
import { createFormData } from '../helpers/createFormdata';
import { getApiErrorMessage, toApiError } from '../utils';
import { useForBindingId } from '../../../forBinding';

export interface OcrExtractSoilPayload {
    file: File;
}

export interface OcrExtractSoilResponse {
    jobId: string;
    status: 'queued';
    analysisType: 'soil';
    createdAt: string;
}

export const usePostOcrExtractSoil = () => {
    const forBinding = useForBindingId();
    return useMutation<OcrExtractSoilResponse, Error, OcrExtractSoilPayload>({
        mutationFn: async (data) => {
            try {
                const formData = createFormData(data);
                const response = await api.post<OcrExtractSoilResponse>('/ocr/extract/soil', formData, {
                    timeout: OCR_TIMEOUT_MS,
                    params: { forBinding }
                });
                return response.data;
            } catch (error) {
                throw toApiError(error, 'Erro ao extrair análise de solo');
            }
        },
        onSuccess: () => { },
        onError: (error) => {
            console.error(
                'Erro ao extrair análise de solo:',
                getApiErrorMessage(error, 'Erro ao extrair análise de solo')
            );
        },
    });
}
